module.exports = __webpack_public_path__ + "img/image_15.2c31e53e.png";